import classNames from "classnames";
import connectToStores from "alt-utils/lib/connectToStores";
import moment from "moment";
import React, { Component } from "react";

import ChatActions from "../../../actions/ChatActions";
import ConfigStore from "../../../stores/chat/ConfigStore";
import SvgIcon from "../../common/SvgIcon";
import iconSprite from "../../../../../images/img/chat/icons.svg";
import PotentialExpertsStore from "../../../stores/chat/PotentialExpertsStore";
import { createSanitizedMarkup } from "../../../utils/Utils";

class NotifyingExpertsSystemMessage extends Component {
    componentDidMount() {
        const { configId, experts, question } = this.props;

        if (experts.length === 0) {
            ChatActions.loadPotentialExperts.defer({
                questionUuid: question.uuid,
                configId,
            });
        } else if (experts.length > 1) {
            ChatActions.cyclePotentialExperts.defer();
        }
    }

    componentWillUnmount() {
        ChatActions.clearPotentialExpertsTimer.defer();
    }

    static getStores() {
        return [ConfigStore, PotentialExpertsStore];
    }

    static getPropsFromStores() {
        return {
            configId: ConfigStore.getConfig().id,
            experts: PotentialExpertsStore.getState().experts,
            indexes: PotentialExpertsStore.getState().indexes,
            isLoading: PotentialExpertsStore.getState().isLoading,
        };
    }

    render() {
        const { experts, indexes, isLoading } = this.props;

        const slides = experts.map((expert, key) => {
            const itemClassNames = classNames({
                item: true,
                "is-prev": indexes.prevExpert === key,
                "is-current": indexes.currentExpert === key,
                "is-next": indexes.nextExpert === key,
            });

            return (
                <li className={itemClassNames} key={key}>
                    <div className="icon icon-avatar">
                        <img src={expert.avatarSrc} />
                    </div>
                    <p className="body">
                        <span className="expert-name" dangerouslySetInnerHTML={createSanitizedMarkup(expert.name)} />
                        <br />
                        <span className="expert-last-active-date">
                            {i18n.t("rtm.text.active_expert_from_now", {
                                date: moment(expert.lastActiveDate).fromNow(),
                            })}
                        </span>
                    </p>
                </li>
            );
        });

        return (
            <li>
                <div className="system-message has-sibling message-alerting-experts-leave-info">
                    <div className="icon icon-bell">
                        <SvgIcon src={iconSprite} id="icon-bell" />
                    </div>
                    <p className="body">
                        <strong>{i18n.t("rtm.text.we_are_notifiying_our_experts")}</strong>
                        <br />
                        {i18n.t("rtm.text.if_you_leave")}
                    </p>
                </div>

                <div className="system-message alerting-experts message-alerting-experts">
                    {experts.length === 0 || isLoading ? (
                        <ul className="expert-carousel">
                            <div className="icon icon-avatar" />
                            <p className="body">
                                <span className="expert-name" />
                                <br />
                                <span className="expert-last-active-date" />
                            </p>
                        </ul>
                    ) : (
                        <ul className="expert-carousel">{slides}</ul>
                    )}
                </div>
            </li>
        );
    }
}

export default connectToStores(NotifyingExpertsSystemMessage);
